import {ReactionType} from "../../../common/video/models/Video";
import React from "react";

interface ReactionEmojiProps {
    reaction: ReactionType;
}

export default function ReactionEmoji({reaction}: ReactionEmojiProps) {
    switch (reaction) {
        case "CHEERS":
            return (
                <span role="img" aria-label="cheers">🍻</span>
            );
        case "LIKE":
            return (
                <span role="img" aria-label="like">👍</span>
            );
        case "SURPRISED":
            return (
                <span role="img" aria-label="surprised">😮</span>
            );
        default:
            return (
                <span role="img" aria-label="default">❔</span>
            );
   }
}
